import { ClientAccount, InvoiceRecord, ActivityLog } from '../types';

export const SEED_ACCOUNTS: ClientAccount[] = [
  {
    id: 'cli-1',
    name: 'Sarah Jenkins',
    company: 'Vanguard Creative Ltd',
    email: 'sarah@vanguardcreative.co',
    phone: '+1 (555) 438-9210',
    address: '840 Broadway, Floor 4\nNew York, NY 10003',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 5).toISOString() // 5 days ago
  },
  {
    id: 'cli-2',
    name: 'Marcus Thorne',
    company: 'Apex Digital Systems',
    email: 'm.thorne@apexdigital.io',
    phone: '+44 20 7946 0192',
    address: 'Level 12, Broadgate Tower\nLondon, EC2M 2QS',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3).toISOString() // 3 days ago
  },
  {
    id: 'cli-3',
    name: 'Kaito Tanaka',
    company: 'Omni Retail Japan',
    email: 'tanaka@omni-retail.jp',
    phone: '+81 3 5555 0143',
    address: '6-Chome-10-1 Roppongi, Minato-ku\nTokyo 106-6108',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 1).toISOString() // 1 day ago
  }
];

export const SEED_INVOICES = (baseElements: any[]): InvoiceRecord[] => {
  // If no baseElements are passed, we shouldn't fail
  const elementsPreset = baseElements && baseElements.length > 0 ? baseElements : [];

  return [
    {
      id: 'inv-seed-1',
      invoiceNumber: 'INV-2026-001',
      clientName: 'Sarah Jenkins',
      clientEmail: 'sarah@vanguardcreative.co',
      amount: 1420.00,
      status: 'paid',
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 4).toISOString(), // 4 days ago
      elements: JSON.parse(JSON.stringify(elementsPreset)),
      pageSize: 'A4'
    },
    {
      id: 'inv-seed-2',
      invoiceNumber: 'INV-2026-002',
      clientName: 'Marcus Thorne',
      clientEmail: 'm.thorne@apexdigital.io',
      amount: 3850.50,
      status: 'paid',
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2).toISOString(), // 2 days ago
      elements: JSON.parse(JSON.stringify(elementsPreset)),
      pageSize: 'A4'
    },
    {
      id: 'inv-seed-3',
      invoiceNumber: 'INV-2026-003',
      clientName: 'Kaito Tanaka',
      clientEmail: 'tanaka@omni-retail.jp',
      amount: 920.00,
      status: 'pending',
      createdAt: new Date().toISOString(),
      elements: JSON.parse(JSON.stringify(elementsPreset)),
      pageSize: 'A4'
    }
  ];
};

export const SEED_LOGS: ActivityLog[] = [
  {
    id: 'log-1',
    action: 'SYSTEM_STARTUP',
    details: 'cloudairambo Invoice generator initialized with beautiful seed accounts & demo billing ledgers.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString()
  },
  {
    id: 'log-2',
    action: 'INVOICE_GENERATED',
    details: 'Demonstration invoice INV-2026-001 automatically archived to sandbox local storage state.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 1.5).toISOString()
  },
  {
    id: 'log-3',
    action: 'CLIENT_ADDED',
    details: 'Client "Marcus Thorne (Apex Digital Systems)" registered to system sandbox database.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60).toISOString()
  }
];

// Helper to save a log record
export const addLogItem = (logs: ActivityLog[], action: string, details: string): ActivityLog[] => {
  const newLog: ActivityLog = {
    id: `log-${Date.now()}`,
    action,
    details,
    timestamp: new Date().toISOString()
  };
  const updated = [newLog, ...logs];
  localStorage.setItem('cloudairambo_logs', JSON.stringify(updated.slice(0, 100))); // limit to 100
  return updated;
};
